import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

//CREATE PRODUCT

export const CreateProductsApi = createAsyncThunk(
  "client/crate-product",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/product/api/v1/crate-product`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("created request of product", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// Single Delte product

export const SingleDeleteProduct = createAsyncThunk(
  "client/sdelete-product",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.delete(
        `${baseUrl}vancouverapis/admin/product/api/v1/delete-product/${data}`,

        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("single delete request of product", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// multiply products delete

export const MultipleDeleteProduct = createAsyncThunk(
  "client/mdelete-product",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/product/api/v1/delete-product`,
        data,

        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("multiple delete request of product", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// UPDATE PRODUCT

export const UpdateProductApi = createAsyncThunk(
  "client/update-product",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    console.log("This is updateprouct api data ", data);
    const Rowid = data.ROWID;

    try {
      const response = await axios.put(
        `${baseUrl}vancouverapis/admin/product/api/v1/update-product/${Rowid}`,
        data,

        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("updated request of product", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

//get count products

export const GetProductCount = createAsyncThunk(
  "client/get-product-count",
  async (_, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.get(
        `${baseUrl}vancouverapis/admin/product/api/v1/product-count`,

        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("get product count", response);
      return response.data; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

export const getDynamicProductList = async (data) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/product/api/v1/get-dynamic-list`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      // console.log("finalconfimredta dd", response);
      return response.data; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }
